import React, { ChangeEvent } from 'react'
import { Upload } from 'lucide-react'
import { FileUploaderProps } from './types'
import { useTranslation } from '@/hooks/useTranslation'

const FileUploader: React.FC<FileUploaderProps> = ({ label, fileType, refId, isUploading, onUpload, inputRef }) => {
  const { t } = useTranslation()

  const isImageType = fileType?.toLowerCase().includes('image') || fileType?.toLowerCase().includes('img')

  const getUploadButtonText = () => {
    if (!fileType) return t('UPLOAD_FILE')
    if (isImageType) return t('UPLOAD_IMAGE')
    if (fileType.toLowerCase().includes('doc') || fileType.toLowerCase().includes('pdf')) return t('UPLOAD_DOCUMENT')
    return t('UPLOAD_FILE')
  }

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files
    if (!files || files.length === 0) return
    const file = files[0]
    if (fileType === 'PDF' && !file.type.includes('pdf')) {
      alert(t('PLEASE_UPLOAD_PDF_FILE'))
      return
    }
    onUpload(file, refId)
  }

  return (
    <div>
      <input
        type="file"
        id={`file-upload-${refId}`}
        accept={fileType === 'PDF' ? 'application/pdf' : isImageType ? 'image/*' : '*'}
        className="hidden"
        onChange={handleFileChange}
        ref={inputRef}
      />
      <button
        className="inline-flex items-center gap-2 h-10 px-4 rounded-[var(--radius)] border border-[hsl(var(--border))] bg-transparent text-sm font-medium text-[hsl(var(--foreground))] hover:bg-[hsl(var(--muted))] transition-colors disabled:opacity-50 disabled:pointer-events-none"
        onClick={() => inputRef.current?.click()}
        disabled={isUploading}
      >
        {isUploading ? <span className="spinner spinner-sm" /> : <Upload className="w-4 h-4" />}
        {isUploading ? t('UPLOADING') : getUploadButtonText()}
      </button>
    </div>
  )
}

export default FileUploader
